import React from 'react';
import { TypographyProps } from 'src/app/atoms/Typography/Typography';
import FeaturedIcon, { FeaturedIconProps } from '../FeaturedIcon/FeaturedIcon';
import HeadingAndSupportingText from '../HeadingAndSupportingText/HeadingAndSupportingText';
import { SpacingPropKeys } from 'src/app/styles/spacing';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { AlignType, DirectionType } from 'src/app/atoms/Layout/Stack/Stack.styles';
import Button, { ButtonProps } from 'src/app/atoms/Button/Button';

export interface IconCardProps {
  heading: TypographyProps;
  supportingText?: TypographyProps;
  featuredIcon: FeaturedIconProps;
  gap?: SpacingPropKeys;
  direction?: DirectionType;
  buttonProps?: ButtonProps;
  align?: AlignType;
}

const IconCard = ({
  gap = 'spacing-xl',
  heading,
  supportingText,
  featuredIcon,
  direction = 'row',
  buttonProps,
  align = 'flex-start',
}: IconCardProps): JSX.Element => {
  return (
    <Stack
      direction={direction}
      gap={gap}
      align={align}
    >
      <FeaturedIcon {...featuredIcon} />
      <Stack paddingTop={direction === 'row' ? 'spacing-md' : null}>
        <HeadingAndSupportingText
          heading={heading}
          supportingText={supportingText}
          gap='spacing-xs'
        />
      </Stack>
      {buttonProps && (
        <Stack>
          <Button {...buttonProps} />
        </Stack>
      )}
    </Stack>
  );
};

export default IconCard;
